exports.shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  document.getElementById("Site-header").scrollIntoView()

  return false
}
